import type { ChatMessage } from '@london-life/contracts';
import { londonWhen } from '../lib/format';

// "Invite over" in a chat (Lagos Life's "@x can walk straight in"): whose home, where, until when, and for the
// friend a button to go over now
export function InviteCard({
  message,
  otherName,
  onGoOver,
}: {
  message: ChatMessage;
  otherName: string;
  onGoOver?: (hostLifeId: string) => void;
}) {
  const invite = message.invite!;
  const status =
    invite.status === 'used'
      ? message.mine
        ? `${otherName} came over`
        : 'You went over'
      : invite.status === 'expired'
        ? 'This invite has run out'
        : message.mine
          ? `${otherName} can walk straight in until ${londonWhen(invite.expiresAt)}. Be home when they come!`
          : `Walk straight in until ${londonWhen(invite.expiresAt)}`;
  return (
    <div className="money-card invite" data-status={invite.status}>
      <div className="money-card-top">
        <span className="money-card-icon" aria-hidden="true">
          🏠
        </span>
        <div>
          <small>
            {message.mine ? `You invited ${otherName} over` : `${message.sender.firstName} invited you over`}
          </small>
          <strong className="gift-name">{invite.homeLabel}</strong>
        </div>
      </div>
      <p className="money-card-what">{invite.area}</p>
      <p className="money-card-status">{status}</p>
      {!message.mine && invite.status === 'open' && onGoOver && (
        <div className="money-card-actions">
          <button type="button" className="house-button save" onClick={() => onGoOver(invite.hostLifeId)}>
            🚶 Go over
          </button>
        </div>
      )}
    </div>
  );
}
